import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useCredentials from '../hooks/useCredentials';
import { storeRedirectUrl } from '../utils/sessionUtils';

const PrivateRoute = () => {
  const { isAuthenticated } = useCredentials();
  const location = useLocation(); // Get current location (URL)

  if (!isAuthenticated) {
    // Store the current URL before redirecting
    storeRedirectUrl();
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
